module.exports = __webpack_public_path__ + "img/sdfc.c39987a2.png";